<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTabs class="stat-tabs" v-model="activeTab" :tabs="tabs"></NevsTabs>

            <!-- Prihod po proizvodima i uslugama -->
            <NevsTab :model-value="activeTab" value="productRevenue">
                <div class="stat-filters">
                    <NevsDateField v-model="state.productRevenue.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.productRevenue.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsMultipleSelect v-model="state.productRevenue.filters.product_ids" :ajax="'select/products'"
                                        :label="$LANG.Get('statistics.products') + ':'" class="stat-filter-wide"></NevsMultipleSelect>
                    <NevsSelect v-model="state.productRevenue.filters.product_group_id" :ajax="'select/product-groups'" :nullable="true"
                                :label="$LANG.Get('statistics.productGroup') + ':'" class="stat-filter"></NevsSelect>
                    <NevsSelect v-model="state.productRevenue.filters.payment_method_id" :ajax="'select/payment-methods'" :nullable="true"
                                :label="$LANG.Get('fields.paymentMethod') + ':'" class="stat-filter"></NevsSelect>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('productRevenue')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.productRevenue.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  :show-invoices-excel="true"
                                  @export="(format) => runExport('productRevenue', format)"></StatisticsResult>
            </NevsTab>

            <!-- Prihod po članarinama -->
            <NevsTab :model-value="activeTab" value="membershipRevenue">
                <div class="stat-filters">
                    <NevsDateField v-model="state.membershipRevenue.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.membershipRevenue.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsMultipleSelect v-model="state.membershipRevenue.filters.membership_ids" :ajax="'select/memberships'"
                                        :label="$LANG.Get('statistics.memberships') + ':'" class="stat-filter-wide"></NevsMultipleSelect>
                    <NevsSelect v-model="state.membershipRevenue.filters.payment_method_id" :ajax="'select/payment-methods'" :nullable="true"
                                :label="$LANG.Get('fields.paymentMethod') + ':'" class="stat-filter"></NevsSelect>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('membershipRevenue')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.membershipRevenue.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  :show-invoices-excel="true"
                                  @export="(format) => runExport('membershipRevenue', format)"></StatisticsResult>
            </NevsTab>

            <!-- Prihod po paketima -->
            <NevsTab :model-value="activeTab" value="packageRevenue">
                <div class="stat-filters">
                    <NevsDateField v-model="state.packageRevenue.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.packageRevenue.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsMultipleSelect v-model="state.packageRevenue.filters.package_ids" :ajax="'select/packages'"
                                        :label="$LANG.Get('statistics.packages') + ':'" class="stat-filter-wide"></NevsMultipleSelect>
                    <NevsSelect v-model="state.packageRevenue.filters.payment_method_id" :ajax="'select/payment-methods'" :nullable="true"
                                :label="$LANG.Get('fields.paymentMethod') + ':'" class="stat-filter"></NevsSelect>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('packageRevenue')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.packageRevenue.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  :show-invoices-excel="true"
                                  @export="(format) => runExport('packageRevenue', format)"></StatisticsResult>
            </NevsTab>

            <!-- Potpuni izvještaj za razdoblje -->
            <NevsTab :model-value="activeTab" value="fullReport">
                <div class="stat-filters">
                    <NevsDateField v-model="state.fullReport.filters.date_from" :label="$LANG.Get('labels.dateFrom') + ':'" class="stat-filter"></NevsDateField>
                    <NevsDateField v-model="state.fullReport.filters.date_to" :label="$LANG.Get('labels.dateTo') + ':'" class="stat-filter"></NevsDateField>
                    <NevsSelect v-model="state.fullReport.filters.payment_method_id" :ajax="'select/payment-methods'" :nullable="true"
                                :label="$LANG.Get('fields.paymentMethod') + ':'" class="stat-filter"></NevsSelect>
                    <NevsButton class="primary stat-filter-button" @click="runFilter('fullReport')">
                        <i class="fa-solid fa-filter"></i> {{ $LANG.Get('buttons.applyFilter') }}
                    </NevsButton>
                </div>
                <StatisticsResult :result="state.fullReport.result" :empty-text="$LANG.Get('labels.noStatisticsData')"
                                  @export="(format) => runExport('fullReport', format)"></StatisticsResult>
            </NevsTab>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsMultipleSelect from "@/components/nevs/NevsMultipleSelect.vue";
import NevsTabs from "@/components/nevs/NevsTabs.vue";
import NevsTab from "@/components/nevs/NevsTab.vue";
import StatisticsResult from "@/components/general/StatisticsResult.vue";
import moment from "moment";

export default {
    name: "FinancialStatistics",
    components: {StatisticsResult, NevsTab, NevsTabs, NevsMultipleSelect, NevsSelect, NevsDateField, NevsButton, NevsCard},
    data() {
        return {
            activeTab: 'productRevenue',
            tabDefs: {
                productRevenue: {endpoint: 'financial-statistics/product-revenue', report: 'product-revenue'},
                membershipRevenue: {endpoint: 'financial-statistics/membership-revenue', report: 'membership-revenue'},
                packageRevenue: {endpoint: 'financial-statistics/package-revenue', report: 'package-revenue'},
                fullReport: {endpoint: 'financial-statistics/full-report', report: 'full-report'}
            },
            state: {
                productRevenue: {filters: this.defaultFilters('productRevenue'), result: null},
                membershipRevenue: {filters: this.defaultFilters('membershipRevenue'), result: null},
                packageRevenue: {filters: this.defaultFilters('packageRevenue'), result: null},
                fullReport: {filters: this.defaultFilters('fullReport'), result: null}
            }
        }
    },
    computed: {
        tabs() {
            return [
                {value: 'productRevenue', label: this.$LANG.Get('statistics.productRevenue')},
                {value: 'membershipRevenue', label: this.$LANG.Get('statistics.membershipRevenue')},
                {value: 'packageRevenue', label: this.$LANG.Get('statistics.packageRevenue')},
                {value: 'fullReport', label: this.$LANG.Get('statistics.fullReport')}
            ];
        }
    },
    watch: {
        // Leaving a tab empties its data and resets its filters.
        activeTab(newTab, oldTab) {
            this.resetTab(oldTab);
        }
    },
    methods: {
        defaultFilters(tab) {
            let filters = {
                date_from: moment().startOf('month').format('YYYY-MM-DD'),
                date_to: moment().endOf('month').format('YYYY-MM-DD'),
                // Every tab can be narrowed to a single payment method; no selection means all of them.
                payment_method_id: null
            };
            if (tab === 'productRevenue') {
                filters.product_ids = [];
                filters.product_group_id = null;
            } else if (tab === 'membershipRevenue') {
                filters.membership_ids = [];
            } else if (tab === 'packageRevenue') {
                filters.package_ids = [];
            }
            return filters;
        },
        resetTab(tab) {
            this.state[tab].filters = this.defaultFilters(tab);
            this.state[tab].result = null;
        },
        runFilter(tab) {
            let vm = this;
            this.$API.APICall('get', this.tabDefs[tab].endpoint, this.state[tab].filters, (data, success) => {
                if (success) {
                    vm.state[tab].result = data;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        runExport(tab, format) {
            let vm = this;
            // "Excel po računima" lists the invoices behind the filtered items via its own endpoint.
            if (format === 'invoices-excel') {
                let params = Object.assign({}, this.state[tab].filters, {report: this.tabDefs[tab].report});
                this.$API.APICall('get', 'financial-statistics/invoices-excel', params, (data, success) => {
                    if (success) {
                        window.open(data.link);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
                return;
            }
            let params = Object.assign({}, this.state[tab].filters, {report: this.tabDefs[tab].report, format: format});
            this.$API.APICall('get', 'financial-statistics/export', params, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'statistics');
        this.$store.commit('selectSubMenu', 'financialStatistics');
        this.$store.commit('setBreadcrumbs', [
            {label: this.$LANG.Get('modules.statistics'), link: null},
            {label: this.$LANG.Get('modules.financialStatistics'), link: null}
        ]);
    }
}
</script>

<style scoped>
.stat-tabs {
    margin-top: 18px;
    margin-bottom: 6px;
}

.stat-filters {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #e1e6ee;
}

.stat-filter {
    flex: 0 1 240px;
    min-width: 0;
}

.stat-filter-wide {
    flex: 0 1 320px;
    min-width: 0;
}

.stat-filters .stat-filter-button {
    flex: 0 0 auto;
    padding: 13px 16px;
    margin-bottom: 5px;
}
</style>
